module.exports = __webpack_public_path__ + "static/media/github_logo_3.cf0bf968.jpg";